/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { LoadSpinnerComponent } from "./load-spinner.component";

@NgModule({
  declarations: [LoadSpinnerComponent],
  exports: [LoadSpinnerComponent],
  imports: []
})
export class LoadSpinnerModule {}
